import { TranslateService } from '@ngx-translate/core';
import * as Domain from '@core/Domain';

export class DomainIit {

  static Init(translateService: TranslateService) {
const domain_LocalResourcesDefinition = new Domain.Domain_LocalResourcesDefinition(translateService);
const globalResourcesDefinition = new Domain.GlobalResourcesDefinition(translateService);
const categoryDTO = new Domain.CategoryDTO(translateService);
const ordersSummary = new Domain.OrdersSummary(translateService);
const orderSummaryItem = new Domain.OrderSummaryItem(translateService);
const weekInfoDTO = new Domain.WeekInfoDTO(translateService);
const student = new Domain.Student(translateService);
const menu = new Domain.Menu(translateService);
const menuItem = new Domain.MenuItem(translateService);
const menuItemCategory = new Domain.MenuItemCategory(translateService);
const team = new Domain.Team(translateService);
const teamImage = new Domain.TeamImage(translateService);
const schoolClass = new Domain.SchoolClass(translateService);
const order = new Domain.Order(translateService);
const parent = new Domain.Parent(translateService);
const orderItem = new Domain.OrderItem(translateService);
const payment = new Domain.Payment(translateService);
const userAcount = new Domain.UserAcount(translateService);
const schoolBreak = new Domain.SchoolBreak(translateService);
const orderSection = new Domain.OrderSection(translateService);
const orderDateSection = new Domain.OrderDateSection(translateService);
const orderGroupDTO = new Domain.OrderGroupDTO(translateService);
const orderGroupItemDTO = new Domain.OrderGroupItemDTO(translateService);
const orderDateGroupDTO = new Domain.OrderDateGroupDTO(translateService);
const orderStudentFlatGroupDTO = new Domain.OrderStudentFlatGroupDTO(translateService);
const country = new Domain.Country(translateService);
const countryHoliday = new Domain.CountryHoliday(translateService);
const notificationManager = new Domain.NotificationManager(translateService);
const email = new Domain.Email(translateService);
const emailHelper = new Domain.EmailHelper(translateService);
const applicationUserAction = new Domain.ApplicationUserAction(translateService);
const applicationUserExternalProfile = new Domain.ApplicationUserExternalProfile(translateService);
const applicationSetting = new Domain.ApplicationSetting(translateService);
const applicationUser = new Domain.ApplicationUser(translateService);
const applicationRole = new Domain.ApplicationRole(translateService);
const applicationOperation = new Domain.ApplicationOperation(translateService);
const applicationPermission = new Domain.ApplicationPermission(translateService);
const applicationClient = new Domain.ApplicationClient(translateService);
const applicationUserLogin = new Domain.ApplicationUserLogin(translateService);
const applicationUserClaim = new Domain.ApplicationUserClaim(translateService);
const profileSetting = new Domain.ProfileSetting(translateService);
const profile = new Domain.Profile(translateService);
const applicationLanguage = new Domain.ApplicationLanguage(translateService);
const applicationTimezoneInfo = new Domain.ApplicationTimezoneInfo(translateService);
const dateTimeFormat = new Domain.DateTimeFormat(translateService);
const applicationTheme = new Domain.ApplicationTheme(translateService);
const fileData = new Domain.FileData(translateService);
const auditEntityConfiguration = new Domain.AuditEntityConfiguration(translateService);
const auditPropertyConfiguration = new Domain.AuditPropertyConfiguration(translateService);
const auditLogEntry = new Domain.AuditLogEntry(translateService);
const auditLogEntryType = new Domain.AuditLogEntryType(translateService);
const auditLogPropertyActionType = new Domain.AuditLogPropertyActionType(translateService);
const workflowExecutionResult = new Domain.WorkflowExecutionResult(translateService);
const workflowContextBase = new Domain.WorkflowContextBase(translateService);
const workflowSchedule = new Domain.WorkflowSchedule(translateService);
 }

}
